import { Component } from '@angular/core';

@Component({
  selector: 'mprd-beats-swap-warning-modal',
  templateUrl: 'beats-swap-warning-modal.component.html',
})
export class BeatsSwapWarningModalComponent {
  public destroy: Function;
  public confirm: Function;
  public jsonProduct: string;

  constructor() {}

  close() {
    this.destroy();
  }

  confirmSwap() {
    if (this.confirm) {
      this.confirm();
    }
    this.destroy();
  }
}
